import { Brain } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface MatchCopilotButtonProps {
  onClick: () => void;
  remainingMessages: number;
  className?: string;
}

export function MatchCopilotButton({ onClick, remainingMessages, className }: MatchCopilotButtonProps) {
  const handleClick = () => {
    console.log('[MatchCopilot] Button tapped!');
    onClick();
  };

  // Se className contém override de position, não aplicar fixed positioning
  const hasPositionOverride = className?.includes('relative') || className?.includes('absolute');

  return (
    <Button
      onClick={handleClick}
      size="lg"
      className={cn(
        // Positioning - pode ser overridden via className
        !hasPositionOverride && "fixed bottom-24 right-2 md:bottom-8 md:right-8",
        
        // z-index: above BottomNav (50), below modals/drawers
        "z-[60]",
        
        // iOS touch fixes - CRITICAL for iOS Safari
        "touch-action-manipulation",
        "pointer-events-auto",
        "[&>*]:pointer-events-none", // only button itself receives events
        
        // Size and shape - Premium FAB
        "h-11 w-11 md:h-14 md:w-14 rounded-full",
        
        // Premium dark graphite surface
        "bg-gradient-to-br from-[hsl(var(--sg7-surface-1))] to-[hsl(var(--sg7-surface-2))]",
        
        // Gold ring/border - SG7 premium
        "ring-1 ring-[hsl(var(--sg7-gold))] ring-offset-1 ring-offset-background md:ring-2 md:ring-offset-2",
        
        // Shadow with gold glow
        "shadow-lg shadow-[hsl(var(--sg7-gold))/20]",
        
        // Tap feedback - scale animation
        "active:scale-95 transition-transform duration-100",
        
        // Hover glow effect
        "hover:shadow-[0_0_20px_hsl(var(--sg7-gold)/40)]",
        
        // iOS Safari tap highlight
        "[-webkit-tap-highlight-color:transparent]",
        
        className
      )}
      title="Match Copilot SG7"
    >
      {/* Gold icon */}
      <Brain className="h-5 w-5 md:h-6 md:w-6 text-[hsl(var(--sg7-gold))]" />
      
      {/* Remaining messages badge - ALWAYS visible with red background */}
      <span className="absolute -top-1.5 -right-1.5 z-10 h-5 min-w-[20px] px-1.5 rounded-full bg-red-600 text-white text-xs font-bold flex items-center justify-center shadow-md ring-2 ring-background">
        {remainingMessages}
      </span>
    </Button>
  );
}
